import { ContactsResponseCodes, ContractResponseCodes } from 'types/errorCodes.ts'
import { TransfoErrorCodes } from 'types/billShock.ts'
import { METRICS_RESPONSE_CODES } from 'store/queries/bolt-api/metrics/constants.ts'
import { ERROR_CODES } from '@boltenergy-be/shared'
import { MAGIC_SESSION_EXPIRED_CODE } from 'constants/auth.ts'

const AXIOS_ERRORS = [
  'ERR_CANCELED', // Request canceled client-side
  'ERR_NETWORK', // Request that never reached the backend: the device lost connectivity or the webview was torn down
  'ECONNABORTED' // Connection the browser tore down mid-flight (navigation, webview teardown, network transition)
] as const

// Fallback code for a request that failed before a response arrived and carried no code of its own
export const UNKNOWN_REQUEST_ERROR_CODE = 'ERR_UNKNOWN'

export const HANDLED_ERRORS: string[] = [
  ...Object.values(TransfoErrorCodes),
  ...Object.values(METRICS_RESPONSE_CODES),
  ...AXIOS_ERRORS,
  ContractResponseCodes.NO_VOLUMES,
  ContractResponseCodes.NO_USABLE_VOLUMES,
  ContactsResponseCodes.SALES_CANNOT_UPDATE_CUSTOMER_CONTACT,
  ERROR_CODES.notACustomer,
  ERROR_CODES.requestedProducerFull,
  MAGIC_SESSION_EXPIRED_CODE
]
